import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserLastActivityTypePipe } from './active-type.pipe';
import { ClonePipe } from './clone.pipe';
import { CnameUrlPipe } from './cnameUrl.pipe';
import { CssUrlPipe } from './css-url.pipe';
import { DateDifferencePipe } from './date-difference.pipe';
import { DateToNgbDatePipe } from './date-to-ngb-date.pipe';
import { FilterPipe } from './filter.pipe';
import { FormatPipe } from './format.pipe';
import { FullNamePipe } from './full-name.pipe';
import { GetBooleanPipe } from './get-boolean.pipe';
import { IncentiveTypePipe } from './incentive-type.pipe';
import { InitialLettersPipe } from './initial-letters.pipe';
import { IsDateInListPipe } from './is-date-in-list.pipe';
import { IsDateInPastPipe } from './is-date-in-past.pipe';
import { IsDateInRangePipe } from './is-date-in-range.pipe';
import { JoinWithPipe } from './join-with.pipe';
import { LanguagePreviewPipe } from './language-preview.pipe';
import { NgbDateToDatePipe } from './ngb-date-to-date.pipe';
import { OrdinalPipe } from './ordinal.pipe';
import { ParseValuePipe } from './parse-value.pipe';
import { PercentagePipe } from './percentage.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeStylePipe } from './safe-style.pipe';
import { SharePipe } from './share.pipe';
import { DateIsSamePipe } from './date-is-same.pipe';
import { DateInMonthPipe } from './date-in-month.pipe';
import { TruncatePipe } from './truncate.pipe';
import { DateRangePipe } from './date-range.pipe';
import { IsDateSamePipe } from './is-date-same.pipe';
import { DatesDurationPipe } from './dates-duration.pipe';
import { StatLabelPipe } from './stat-label.pipe';

const PIPES = [
    InitialLettersPipe,
    JoinWithPipe,
    FullNamePipe,
    CssUrlPipe,
    ClonePipe,
    OrdinalPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    FilterPipe,
    ParseValuePipe,
    CnameUrlPipe,
    PercentagePipe,
    SharePipe,
    UserLastActivityTypePipe,
    IncentiveTypePipe,
    LanguagePreviewPipe,
    GetBooleanPipe,
    DateDifferencePipe,
    IsDateInListPipe,
    IsDateInRangePipe,
    IsDateInPastPipe,
    NgbDateToDatePipe,
    DateToNgbDatePipe,
    FormatPipe,
    DateIsSamePipe,
    DateInMonthPipe,
    TruncatePipe,
    DateRangePipe,
    IsDateSamePipe,
    DatesDurationPipe,
    StatLabelPipe,
];


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [...PIPES],
    exports: [...PIPES]
})
export class PipesModule {

}
